module.exports = __webpack_public_path__ + "static/img/logo67.0952c11.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo67.png
// module id = 8e7t
// module chunks = 1